import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "./sidebar";

import blog1 from "../img/blog-1.png";
import blog2 from "../img/blog-2.png";
import blog3 from "../img/blog-3.png";
import blog4 from "../img/blog-4.png";
import blog5 from "../img/blog-5.png";


// import "./style.css";

const BlogList = () => {
  return (
    <section className="blog-page-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-7">
            <div className="blog-left">
              <div className="row">
                <div className="col-lg-12">
                  <Link
                    to="/The-Pros-and-Cons-of-Buying-New-Construction-vs-Existing-Homes"
                    className="news-box"
                    data-aos="fade-up"
                  >
                    <div className="news-img">
                      <img src={blog1} alt="img" />
                    </div>
                    <div className="news-text">
                      <h3>The Pros and Cons of Buying New Construction vs. Existing Homes</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-12">
                  <Link
                    to="/Understanding-Closing-Costs"
                    className="news-box"
                    data-aos="fade-up"
                  >
                    <div className="news-img">
                      <img src={blog2} alt="img" />
                    </div>
                    <div className="news-text">
                      <h3>Understanding Closing Costs</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-12">
                  <Link
                    to="/Navigating-the-Home-Inspection-Process"
                    className="news-box"
                    data-aos="fade-up"
                  >
                    <div className="news-img">
                      <img src={blog3} alt="img" />
                    </div>
                    <div className="news-text">
                      <h3>Navigating the Home Inspection Process</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-12">
                  <Link
                    to="/How-to-Secure-the-Best-Mortgage-Rates-for-Your-Home-Purchase-in-India"
                    className="news-box"
                    data-aos="fade-up"
                  >
                    <div className="news-img">
                      <img src={blog4} alt="img" />
                    </div>
                    <div className="news-text">
                      <h3>How to Secure the Best Mortgage Rates for Your Home Purchase in India</h3>
                    </div>
                  </Link>
                </div>
                <div className="col-lg-12">
                  <Link
                    to="/10-Essential-Tips-for-First-Time-Home-Buyers-in-India"
                    className="news-box"
                    data-aos="fade-up"
                  >
                    <div className="news-img">
                      <img src={blog5} alt="img" />
                    </div>
                    <div className="news-text">
                      <h3>10 Essential Tips for First-Time Home Buyers in India</h3>
                    </div>
                  </Link>
                </div>
              
              </div>
            </div>
          </div>
          <Sidebar/>
        </div>
      </div>
    </section>
  );
};

export default BlogList;